const actions = {
  confirmSaveState({ dispatch }) {
    dispatch('projectStore/finishProject', {}, { root: true });
  },
};

export default {
  namespaced: true,
  actions,
};
